<template>
  <OareContentView title="Known Issues">
    <template #header>
      <OareBreadcrumbs :items="breadcrumbs" />
    </template>
    <v-row class="text-title-large font-weight-regular justify-center">
      <v-col cols="12" lg="10">
        <p>
          As stated on the front page, the database is still in process and many
          things remain to be rolled out. At present only transliterations are
          offered, and there are a number of known issues with the display of
          transliterations in general. The following are known issues that we
          are working on presently:
        </p>
        <p>
          — Some seal Impressions, uninscribed areas, broken areas, and rulings
          do not display at all, or in some places do not display correctly.
        </p>
        <p>
          — Line numbering is sometimes erroneous. Sometimes these are errors
          associated with the process of converting the texts into the database
          format. But some deviations are programmatic. Please note that in OARE
          line numbering always:
        </p>
        <p>1) starts at 1’ (or 1’’ etc.) after a break.</p>
        <p>2) numbers lines consecutively , and never:</p>
        <p>
          3) numbers cylinder seal impressions that extend across the width of
          the tablet as a line.
        </p>
        <p>
          These practices are followed even where publications accidentally skip
          lines in the numbering sequence, estimate missing lines in a break, or
          number a seal impression as a line. (Where a deviation between the
          publication and the OARE line numbering occurs, a mode of notification
          is planned.)
        </p>
        <p>
          — transliterations place dashes or periods between signs in different
          words (requires relevant signs to be connected to words to fix)
        </p>
        <p>
          — the display of sides (obv., lo.e., rev., u.e., le.e., r.e.) on the
          left of a transliteration are not keyed in correctly sometimes.
        </p>
        <p>
          Thanks for your patience. Please feel free to report any issues
          through
          <a href="mailto:oarefeedback@byu.edu">oarefeedback@byu.edu</a>.
        </p>
        <router-link to="/">Go home</router-link>
      </v-col>
    </v-row>
  </OareContentView>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { BreadcrumbItem } from '@/components/base/OareBreadcrumbs.vue';

export default defineComponent({
  setup() {
    const breadcrumbs = ref<BreadcrumbItem[]>([
      {
        link: '/',
        text: 'Home',
      },
    ]);

    return {
      breadcrumbs,
    };
  },
});
</script>
